/*
 * @Author: cc
 * @Date: 2019-11-25 12:52:25
 * @LastEditTime: 2020-01-17 12:03:55
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\service\versionTime\personalVersionTime\weixinPersonalVersionTime.js
 * @Description:
 */
'use strict';

angular.module('editCenWeixinPersonalVersionTimeModule', []).controller('editCenWeixinPersonalVersionTimeCtrl', [
    '$scope',
    '$sce',
    '$q',
    'trsHttpService',
    '$stateParams',
    function($scope, $sce, $q, trsHttpService, $stateParams) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化参数与状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                listOpen: 3,
                params: {
                    serviceid: 'mlf_extversion',
                    methodname: 'getObjFromVersion',
                    ObjectVersionId: $stateParams.wxobjectversionid,
                },
            };
            $scope.item = '';
            $scope.data = {
                keywords: [],
            };
        }

        /**
         * [initData description]初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            requestData($scope.status.params).then(function(data) {
                $scope.data.item = data;
                $scope.data.item.HTMLCONTENT = $sce.trustAsHtml($scope.data.item.HTMLCONTENT);
                if ($scope.data.item.KEYWORDS) {
                    $scope.data.keywords = $scope.data.item.KEYWORDS.split(';');
                }
            });
        }

        /**
         * [requestData description]数据请求
         * @param  {[obj]} params [description]请求参数
         * @return {[type]}        [description]
         */
        function requestData(params) {
            var deferrd = $q.defer();
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                deferrd.resolve(data);
            });
            return deferrd.promise;
        }
    },
]);
